import {IRWN} from '../IRWN';
import {FSM} from './FSM';

const FSM_INIT = FSM.getState(FSM.stateNames.INIT);
FSM_INIT.enter = function() {
  IRWN.loadAppJson();
};
export {FSM_INIT};
